/* =========================
 iWish FIX (A) PATCHED:
 - Rewrite /iwish?action=add/remove to internal endpoints
 - IMPORTANT: If customer_id is missing, DO NOT rewrite.
   Let iWish handle guest/cookie mode normally.
 ========================= */
(function () {
  if (window.__IWISH_FETCH_PATCHED__) return;
  window.__IWISH_FETCH_PATCHED__ = true;

  var ADD_ENDPOINT = "https://internalapis.myshopapps.com/iwish/V2/addToWishlist";
  var REMOVE_ENDPOINT = "https://internalapis.myshopapps.com/iwish/V2/removeWishlist";
  var BAD_REMOVE_ENDPOINT = "https://internalapis.myshopapps.com/iwish/V2/removeFromWishlist";

  var origFetch = window.fetch.bind(window);

  function getShopDomain() {
    return (
      (window.__IWISH_SHOP_DOMAIN__ && String(window.__IWISH_SHOP_DOMAIN__).trim()) ||
      (window.Shopify && Shopify.shop) ||
      window.location.hostname
    );
  }

  function getCustId() {
    return String(
      (window.__IWISH_CUSTOMER_ID__ && window.__IWISH_CUSTOMER_ID__) ||
      (window.iWish && (window.iWish.custId || window.iWish.customer_id)) ||
      ""
    ).trim();
  }

  function postForm(endpoint, formObj) {
    var shopDomain = getShopDomain();
    if (!shopDomain) return null;

    var body = new URLSearchParams(formObj).toString();

    return origFetch(endpoint, {
      method: "POST",
      mode: "cors",
      credentials: "omit",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        domain: shopDomain,
        "X-Shopify-Shop-Domain": shopDomain,
      },
      body: body,
      cache: "no-store",
    });
  }

  window.fetch = function (input, init) {
    try {
      var urlStr =
        typeof input === "string"
          ? input
          : input && input.url
          ? input.url
          : "";

      if (!urlStr) return origFetch(input, init);

      // Normalize bad endpoint (keep existing behavior)
      if (urlStr.indexOf(BAD_REMOVE_ENDPOINT) === 0) {
        if (init) return origFetch(REMOVE_ENDPOINT, init);
        return origFetch(REMOVE_ENDPOINT);
      }

      var u = new URL(urlStr, window.location.origin);

      // Intercept ONLY the proxy endpoint iWish uses
      if (u.pathname === "/iwish") {
        var action = (u.searchParams.get("action") || "").trim();
        if (action !== "add" && action !== "remove") return origFetch(input, init);

        var variant = (u.searchParams.get("variant") || "").trim();
        var product = (u.searchParams.get("product") || "").trim();

        if (!product || !variant) return origFetch(input, init);

        // ✅ KEY FIX: If we don't have a real customer id, do not rewrite.
        // This prevents "removed items come back" for guest/cookie mode
        // and avoids silent no-op removes.
        var custId = getCustId();
        if (!custId) return origFetch(input, init);

        if (action === "add") {
          return (
            postForm(ADD_ENDPOINT, {
              customer_id: custId,
              product_id: product,
              variant_id: variant,
            }) || origFetch(input, init)
          );
        }

        if (action === "remove") {
          return (
            postForm(REMOVE_ENDPOINT, {
              customer_id: custId,
              product_id: product,
              variant_id: variant,
              category_id: "0",
            }) || origFetch(input, init)
          );
        }
      }
    } catch (e) {}

    return origFetch(input, init);
  };
})();

/* =========================
 iWish FIX (B) PATCHED:
 Product Recommendations buttons
 - Keeps your behavior but updates header counter consistently
 ========================= */
(function () {
  if (window.__IWISH_REC_PATCHED__) return;
  window.__IWISH_REC_PATCHED__ = true;

  var SEL =
    "product-recommendations a.iWishAddColl.iwishcheck[data-product][data-variant]";

  function setHeaderCounterAll(n) {
    var nodes = document.querySelectorAll(".iwish-counter");
    if (!nodes || !nodes.length) return;
    var v = String(Math.max(0, Number(n) || 0));
    nodes.forEach(function (el) {
      el.textContent = v;
    });
  }

  function bumpCounter(delta) {
    if (typeof window.__iwishCount !== "number") window.__iwishCount = 0;
    window.__iwishCount = Math.max(0, window.__iwishCount + delta);
    setHeaderCounterAll(window.__iwishCount);
    if (window.__refreshIwishUI__) window.__refreshIwishUI__();
  }

  function bindOne(btn) {
    if (btn.__iwishBound) return;
    btn.__iwishBound = true;

    btn.addEventListener(
      "click",
      function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        var product = btn.getAttribute("data-product");
        var variant = btn.getAttribute("data-variant");
        if (!product || !variant) return;

        if (btn.dataset.iwishBusy === "1") return;
        btn.dataset.iwishBusy = "1";

        var isAdded = btn.classList.contains("iwish-added");
        var action = isAdded ? "remove" : "add";

        fetch(
          "/iwish?action=" +
            action +
            "&variant=" +
            encodeURIComponent(variant) +
            "&product=" +
            encodeURIComponent(product)
        )
          .then(function (res) {
            if (!res.ok) throw new Error("HTTP " + res.status);
            return res.text();
          })
          .then(function () {
            if (action === "add") {
              btn.classList.add("iwish-added");
              btn.setAttribute("aria-pressed", "true");
              bumpCounter(+1);
            } else {
              btn.classList.remove("iwish-added");
              btn.setAttribute("aria-pressed", "false");
              bumpCounter(-1);
            }
          })
          .finally(function () {
            btn.dataset.iwishBusy = "0";
          });
      },
      true
    );
  }

  function bindAll(root) {
    (root || document).querySelectorAll(SEL).forEach(bindOne);
  }

  function init() {
    bindAll(document);
  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
  document.addEventListener("shopify:section:reorder", init);

  var pr = document.querySelector("product-recommendations");
  if (pr && window.MutationObserver) {
    var obs = new MutationObserver(function () {
      init();
    });
    obs.observe(pr, { childList: true, subtree: true });
  }
})();

/* =========================
 iWish FIX (C) PATCHED:
 - Counter source of truth: .iwish-counter (your header uses this)
 - Wishlist page: debounced refresh, observe ONLY wishlist container
 - Prevents slow loading + infinite refresh loops
 ========================= */
(function () {
  if (window.__IWISH_UI_PATCHED__) return;
  window.__IWISH_UI_PATCHED__ = true;

  var onWishlistPage = /\/apps\/iwish/i.test(location.pathname);

  function setHeaderCounterAll(n) {
    var nodes = document.querySelectorAll(".iwish-counter");
    if (!nodes || !nodes.length) return;
    var v = String(Math.max(0, Number(n) || 0));
    nodes.forEach(function (el) {
      el.textContent = v;
    });
  }

  // seed from DOM
  if (typeof window.__iwishCount !== "number") {
    var seedEl = document.querySelector(".iwish-counter");
    var seed = parseInt((seedEl && seedEl.textContent) || "0", 10);
    window.__iwishCount = isNaN(seed) ? 0 : seed;
  }

  // expose global renderer
  window.__renderIwishCounter__ = function () {
    setHeaderCounterAll(window.__iwishCount || 0);
  };

  document.addEventListener("DOMContentLoaded", function () {
    window.__renderIwishCounter__();
  });

  if (!onWishlistPage) return;

  function getWishlistCount() {
    // Prefer iWish item element if present
    var c = document.querySelectorAll(".iwishProducts .iwishItem").length;
    if (c) return c;

    // Fallbacks (some templates differ)
    var b = document.querySelectorAll(".iwishItem").length;
    if (b) return b;

    var a = document.querySelectorAll(".iwishProducts .grid__item").length;
    return a || 0;
  }

  function forceEmptyMessage(isEmpty) {
    var msg = document.querySelector(".iwishMsgInfo");
    if (!msg) return;
    if (isEmpty) {
      msg.style.removeProperty("display");
      msg.style.setProperty("display", "", "important");
    } else {
      msg.style.setProperty("display", "none", "important");
    }
  }

  function forceGrid() {
    var grid = document.querySelector(".iwishProducts");
    if (!grid) return;
    // Don't let JS keep toggling display during render
    grid.style.removeProperty("display");
  }

  function refreshIwishUI() {
    var n = getWishlistCount();
    window.__iwishCount = n;
    setHeaderCounterAll(n);

    var isEmpty = n === 0;
    forceEmptyMessage(isEmpty);
    forceGrid();
  }

  window.__refreshIwishUI__ = refreshIwishUI;

  // Debounce (main performance fix)
  var t = null;
  function scheduleRefresh(delay) {
    if (t) clearTimeout(t);
    t = setTimeout(function () {
      t = null;
      refreshIwishUI();
    }, delay || 250);
  }

  document.addEventListener("DOMContentLoaded", function () {
    scheduleRefresh(400);
    scheduleRefresh(1200);
  });

  function startObserver() {
    // Observe ONLY wishlist container (not body/page-width)
    var target =
      document.querySelector(".iwishProducts") ||
      document.querySelector(".iwishWrapper");

    if (!target || !(target instanceof Node)) {
      setTimeout(startObserver, 300);
      return;
    }

    if (!window.MutationObserver) return;

    try {
      var obs = new MutationObserver(function () {
        scheduleRefresh(300);
      });
      obs.observe(target, { childList: true, subtree: true });
    } catch (e) {}
  }

  startObserver();
})();


/* =========================================================
   GLOBAL: Cart Drawer Empty State Toggle
   (Used by JM Cart Badge Sync)
   ========================================================= */
window.jmToggleCartDrawerEmptyState = function (itemCount) {
  var drawer = document.querySelector('#CartDrawer');
  if (!drawer) return;

  var inner = drawer.querySelector('.drawer__inner');
  var empty = drawer.querySelector('.drawer__cart-empty');

  var isEmpty = (Number(itemCount) || 0) === 0;

  if (inner) inner.style.display = isEmpty ? 'none' : '';
  if (empty) empty.style.display = isEmpty ? '' : 'none';

  drawer.classList.toggle('is-empty', isEmpty);
  drawer.classList.toggle('has-items', !isEmpty);
};

/* =========================================================
   GLOBAL: Wholesale Threshold UI Sync (Cart Drawer)
   Updates:
   - subtotal [data-subtotal]
   - threshold message [data-jm-threshold-message]
   - checkout wrapper [data-jm-checkout-wrapper]
   ========================================================= */

window.JM_THRESHOLD_CENTS = 20000; // $200.00

window.jmFormatMoney = function (cents) {
  var value = Number(cents) || 0;

  // 1) Impulse currency formatter (best if present)
  try {
    if (window.theme && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function') {
      return window.theme.Currency.formatMoney(value);
    }
  } catch (e) {}

  // 2) Shopify formatter (good)
  try {
    var fmt =
      (window.theme && window.theme.settings && window.theme.settings.moneyFormat) ||
      (window.theme && window.theme.moneyFormat) ||
      window.shop_money_format ||
      '${{amount}}';

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(value, fmt);
    }
  } catch (e2) {}

  // 3) Fallback (still show currency symbol)
  return '$' + (value / 100).toFixed(2);
};


window.jmUpdateDrawerThresholdUI = function (cart) {
  var drawer = document.querySelector('#CartDrawer');
  if (!drawer || !cart) return;

  // Subtotal
  var subtotalEl = drawer.querySelector('[data-subtotal]');
  if (subtotalEl && typeof cart.total_price !== 'undefined') {
    subtotalEl.textContent = window.jmFormatMoney(cart.total_price);
  }

  // Threshold + checkout toggle
  var msg =
    drawer.querySelector('[data-jm-threshold-message]') ||
    drawer.querySelector('.cart__less-than-200') ||
    drawer.querySelector('.cart_less-than-200');

  var checkoutWrap =
    drawer.querySelector('[data-jm-checkout-wrapper]') ||
    drawer.querySelector('.cart__checkout-wrapper');

  var below = (Number(cart.total_price) || 0) < window.JM_THRESHOLD_CENTS;

  if (msg) msg.style.display = below ? '' : 'none';
  if (checkoutWrap) checkoutWrap.style.display = below ? 'none' : '';
};

/* Simple helper: fetch latest cart and update UI */
window.jmSyncDrawerThresholdFromServer = function () {
  return fetch('/cart.js', {
    credentials: 'same-origin',
    headers: { 'Accept': 'application/json' }
  })
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      window.jmUpdateDrawerThresholdUI(cart);
      if (typeof cart.item_count !== 'undefined' && typeof window.jmToggleCartDrawerEmptyState === 'function') {
        window.jmToggleCartDrawerEmptyState(cart.item_count);
      }
      return cart;
    })
    .catch(function (err) {
      console.warn('[JM] jmSyncDrawerThresholdFromServer failed:', err);
    });
};




const JM_HAS_JQ = typeof window.jQuery !== "undefined";

if (JM_HAS_JQ) {
/*JM Added for cfaq banner image*/
jQuery(document).ready(function($) {
  $( ".index-section.index-section--faq" ).append( "<img src='https://cdn.shopify.com/s/files/1/1633/6641/files/faq-banner.webp?v=1658845741' width='100%' class='lazyautosizes lazyloaded' alt='Altenew' data-sizes='auto' sizes='272px'>" );
});

/*JM Added for collection page drawer clear all filter*/
$(document).ready(function() {
   var uri = window.location.toString();
   setInterval(function () {
       if (window.location.href.indexOf("?filter") > -1) {
              $('#clear-all-button').on("click", function(){
              var clean_uri = uri.substring(0, uri.indexOf("?"));
              window.location.href = window.location.href.split('?')[0]; 
    		});
			$("#clear-all-button").css("display","block");
       }else{
       	$("#clear-all-button").css("display","none");
       }
    },1000);
});

//JM Added for 404 error image
jQuery(document).ready(function($) {
  $( "header.section-header.section-header--404" ).append( "<a href='https://wholesale.altenew.com/'><img src='https://cdn.shopify.com/s/files/1/1633/6641/files/Altnew-404-Page-Banner.jpg?v=1659018449' width='100%' class='lazyautosizes lazyloaded' alt='Altenew' data-sizes='auto' sizes='272px'></a>" );
});

//Klaviyo update text on collection list 


/*Option 1 for products with a lot of images horizontal view*/
$( document ).ready(function() {
    $( ".template-product .product-section .product__thumbs--below .product__thumb-item" ).each(function() {
	  var getCount = $(this).attr('data-index');
	  if(getCount > 14){
	  $(".template-product .product-section .product__thumbs--below").css({
			 'max-height': '300px',
		    'overflow-x': 'hidden',
		    'overflow-y': 'scroll'
		})
	}
	});
});


// /*Hide/Show Notify Me When Available For Variant Options 03-8-2023*/
//  $( document ).ready(function() {
//    var PDP_btn_text = $(".jmc-cart-wishlist.right button.btn.btn--full.add-to-cart.btn--secondary span").text();
//    if ($.trim(PDP_btn_text) == "Add to cart"){
//            $("#notify-me-variant-options").css("display","none");
//            $(".jmc-cart-wishlist.left .variant-input-wrap select option").removeAttr("disabled");
//       }else{
//          $("#notify-me-variant-options").css("display","block");
//          $(".jmc-cart-wishlist.left .variant-input-wrap select option").attr("disabled","disabled");
//       }
//    $('.jmc-cart-wishlist.left .variant-input-wrap select').on('change', function() { 
//          var PDP_btn_text = $(".jmc-cart-wishlist.right button.btn.btn--full.add-to-cart.btn--secondary span").text();
//          if (PDP_btn_text == "Sold Out"){
//            $("#notify-me-variant-options").css("display","block");
//            $(".inventoryWrapper").css("display","none");
//          }else {
//            $(".inventoryWrapper").css("display","block");
//          }
//      console.log(PDP_btn_text);
//   });
// });

/*Collection Page fix Notify Me button missing when using filter 5-4-2023*/
$(document).ready(function () {
    $("div#FilterDrawer li.tag").click(function () {
      setTimeout(function() {
     location.reload(true);
    }, 1000);
    });
});


/* FIX: Footer HELP links opening in a NEW TAB (Safari/iOS)
   - Removes target="_blank" in the footer
   - Forces SAME-TAB navigation using CAPTURE-phase click interception
   - Works even if some script keeps re-adding target="_blank"
*/
document.addEventListener('DOMContentLoaded', function () {
  const footerEl = document.querySelector('footer');
  if (!footerEl) return;

  function isForcedSameTabLink(anchorEl) {
    if (!anchorEl) return false;

    const rawHref = anchorEl.getAttribute('href');
    if (!rawHref) return false;

    // Internal relative links should stay same-tab
    if (rawHref.startsWith('/')) return true;

    // Absolute links to wholesale domain should stay same-tab
    try {
      const url = new URL(anchorEl.href, window.location.href);
      if (url.hostname === 'wholesale.altenew.com') return true;
    } catch (e) {
      // If URL parsing fails, do nothing
    }

    return false;
  }

  function stripNewTabAttrsInFooter() {
    const links = footerEl.querySelectorAll('a[target="_blank"], a[rel]');
    links.forEach(function (a) {
      // Only strip for links we want to keep same-tab
      if (isForcedSameTabLink(a)) {
        a.removeAttribute('target');
        a.removeAttribute('rel');
      }
    });
  }

  // 1) Strip immediately
  stripNewTabAttrsInFooter();

  // 2) Keep stripping if something re-injects it
  const mo = new MutationObserver(function () {
    stripNewTabAttrsInFooter();
  });
  mo.observe(footerEl, { subtree: true, childList: true, attributes: true, attributeFilter: ['target', 'rel', 'href'] });

  // 3) HARD STOP: Intercept clicks in CAPTURE phase and force same-tab navigation
  footerEl.addEventListener('click', function (e) {
    const a = e.target && e.target.closest ? e.target.closest('a') : null;
    if (!a) return;

    if (!isForcedSameTabLink(a)) return;

    // Stop Safari from opening a new tab even if target="_blank" exists
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

    window.location.assign(a.href);
  }, true);
});

/*SMS Subscription Form Wholesale*/
 $(document).ready(function() {
    // Function to disable the button
    function disableButton() {
      $(".klaviyo-form-RfPSZW.klaviyo-form button[aria-label='Search Countries']").prop('disabled', true);
    }
    // Call the function after 3 seconds
    setTimeout(disableButton, 2000); // 3000 milliseconds = 3 seconds
  });

/*Layering guides page custom search 09-28-2023*/
$( document ).ready(function() {
  var acc = document.getElementsByClassName("accordion");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].onclick = function() {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight){
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      } 
    }
  }
  
  // Store the input fields as variables
  var $barInput = $('.bar-input');
  var $layeringInstructions = $('.layering-instructions');
  var $layeringStencil = $('.layering-stencil');
  var $pressPlates = $('.press-plates');

  // Reusable function for handling accordions
  function handleAccordion(inputElement, accordionContainer, backgroundColorClass) {
    var inputVal = inputElement.val().toLowerCase();
    var accordions = accordionContainer.find('.accordion');
    var searchCount = 0;

    accordions.each(function () {
      var accordion = $(this);
      var panel = accordion.next('.panel');
      var listItems = panel.find('ul li');
      var matchCount = 0;

      listItems.each(function () {
        var listItem = $(this);
        var textContent = listItem.text().toLowerCase();

        if (!inputVal || textContent.indexOf(inputVal) > -1) {
          listItem.css('display', 'list-item');
          matchCount++;
        } else {
          listItem.css('display', 'none');
        }
      });

      if (matchCount === 0) {
        accordion.removeClass('active');
        accordion.removeClass(backgroundColorClass);
        panel.css('max-height', '0'); // Close the panel
      } else {
        accordion.addClass('active'); // Add 'active' class
        accordion.addClass(backgroundColorClass); // Add background color class
        panel.css('max-height', '1000px'); // Open the panel (adjust '1000px' as needed)
      }

      searchCount += matchCount;
    });

    if (inputVal === "") {
      accordions.removeClass('active');
      accordions.removeClass(backgroundColorClass);
      accordions.show(); // Show all accordions when the input is empty
      var panels = accordionContainer.find('.panel');
      panels.css('max-height', ''); // Reset max-height for all panels
    } else {
      accordions.not('.active').hide(); // Hide non-active accordions
    }

    if (searchCount < 318 && searchCount !== 0) {
      accordionContainer.find('.no-results').css("display", "none");
    } else if (searchCount === 0) {
      accordionContainer.find('.no-results').css("display", "block");
    }
  }

  // Attach event handlers
  $barInput.on('keyup', function () {
    handleAccordion($barInput, $('#layering-guides'), 'background-color-class1');
  });

  $layeringInstructions.on('keyup', function () {
    handleAccordion($layeringInstructions, $('#layering-instructions'), 'background-color-class2');
  });

  $layeringStencil.on('keyup', function () {
    handleAccordion($layeringStencil, $('#layering-stencil'), 'background-color-class3');
  });

   $pressPlates.on('keyup', function () {
    handleAccordion($pressPlates, $('#press-plates'), 'background-color-class3');
  });


  
  /*All links open in new tab 12/10/2024*/
  $('#layering-guides a, #layering-instructions a, #layering-stencil a, #marvelous-monthly-series a','#press-plates a').attr('target', '_blank');
  
});

/*Update the new/best/sale menu link*/
$(document).ready(function() {
    // Define the target URL
    var targetUrl = 'https://wholesale.altenew.com/collections/new';

    // Find the anchor tag with the specific href attribute
    var $targetAnchorDesktop = $('div#HeaderWrapper a[href="' + targetUrl + '"]');

    // Check if the anchor tag with the specified URL exists
    if ($targetAnchorDesktop.length > 0) {
      // Update the text content
      $targetAnchorDesktop.html('NEW<span class="dot">•</span>BEST <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16"><path d="m1.57 1.59 12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none"></path></svg>'); // Replace with your desired text
    }
  });

$(document).ready(function() {
    // Define the target URL
    var targetUrl = 'https://wholesale.altenew.com/collections/new';

    // Find the anchor tag with the specific href attribute
    var $targetAnchorMobile = $('.mobile-nav__has-sublist a[href="' + targetUrl + '"]');

    // Check if the anchor tag with the specified URL exists
    if ($targetAnchorMobile.length > 0) {
      // Update the text content
      $targetAnchorMobile.html('NEW<span class="dot">•</span>BEST <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16"><path d="m1.57 1.59 12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none"></path></svg>'); // Replace with your desired text
    }
  });


//Searchnise Product Subscription/Sneak Peak on Search Page
$(document).ready(function () {
   if (window.location.href.indexOf("https://wholesale.altenew.com/pages/search-results-page?q") > -1) {
         setTimeout(function(){
          $('#snize-search-results-grid-mode ul li').each(function () {
          if($(this).hasClass("snize-product-out-of-stock")){
             $("#snize-search-results-grid-mode li.snize-product-out-of-stock .snize-button").html('<svg style="color: #3c3c3c" xmlns="http://www.w3.org/2000/svg" width="17" height="17" fill="currentColor" class="bi bi-envelope" viewBox="0 0 16 16"> <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z" fill="#3c3c3c"></path> </svg> Notify Me');
          }else if($(this).hasClass("snize-product-tag-sneak_peek")) {
             $("#snize-search-results-grid-mode li.snize-product.snize-product-tag-sneak_peek .snize-button").text("More Info");
             $("#snize-search-results-grid-mode li.snize-product.snize-product-tag-sneak_peek .snize-button").removeClass( "snize-add-to-cart-button");
           }else if($(this).hasClass("snize-product-tag-promo_ink-cube")) {
             $("#snize-search-results-grid-mode li.snize-product.snize-product-tag-promo_ink-cube .snize-button").text("More Info");
             $("#snize-search-results-grid-mode li.snize-product.snize-product-tag-promo_ink-cube .snize-button").removeClass( "snize-add-to-cart-button");
           }
          });
         }, 3000); //run this after 3 seconds
  };
});

/*Hide/Show Notify Me When Available For Variant Options improve to handle pre-order options 3-1-2024*/
 $( document ).ready(function() {
   var PDP_btn_text = $(".jmc-cart-wishlist.right button.btn.btn--full.add-to-cart.btn--secondary span").text();
    if ($.trim(PDP_btn_text) == "Add to cart"){
           $("#notify-me-variant-options").css("display","none");
           $(".jmc-cart-wishlist.left .variant-input-wrap select option").removeAttr("disabled");
      }else{
         $("#notify-me-variant-options").css("display","block");
         $(".jmc-cart-wishlist.left .variant-input-wrap select option").removeAttr("disabled");
         $(".inventoryWrapper").css("display","none");
      }
   
       // Function to synchronize selections between Select 1 and Select 2
        function syncSelectOptions() {
            // Get the selected index from Select 1
            var selectedIndex = $('.variant-wrapper.variant-wrapper--dropdown .variant-input-wrap select').prop('selectedIndex');
            // Set the corresponding option in Select 2 as selected
            $('select.product-single__variants.no-js').prop('selectedIndex', selectedIndex);
        }

        // Run the function when the page loads
        syncSelectOptions();

   
          // Function to check the selected option
          function checkSelectedOption() {
               var selectedOption = $('option:selected', 'select.product-single__variants.no-js');
               var attributeValue = selectedOption.attr('continuesellingoos');
               var ProductTypeJM = $("input.ProductTypeJM").val();
               var PreOrderJM = $("input.PreOrderJM").val();
               var RegisterJM = $("input.RegisterJM").val();
               var JoinWaitListJM = $("input.JoinWaitListJM").val();
               console.log(34, attributeValue);
               console.log(ProductTypeJM);
               console.log(RegisterJM);
               
                 if(attributeValue=="continue"){
                   if (ProductTypeJM !== "Class" && ProductTypeJM !== "Class Bundle" && ProductTypeJM !== "Workshop"  && ProductTypeJM !== "Gift Cards" && RegisterJM === "false")  {
                     $("h2.shipping-period").css("display","block");
                     $(".jmc-cart-wishlist.right button.btn.btn--full.add-to-cart.btn--secondary span").text("Pre-Order");
                     console.log(22, $(".jmc-cart-wishlist.left button.btn.btn--full.add-to-cart.btn--secondary span"));
                     $(".jmc-cart-wishlist.left button.btn.btn--full.add-to-cart.btn--secondary span, .btn.btn--full.add-to-cart").text("Pre-Order");
                     $(".jmc-cart-wishlist.right button.btn.btn--full.add-to-cart.btn--secondary").prop('disabled', false);
                     $("div#custom-sticky-header-jm button").prop('disabled', false);
                     $("div#custom-sticky-header-jm button span").text("PRE-ORDER");
                     $("div#custom-sticky-header-jm button").css("background-color","#000");
                     $("div#custom-sticky-header-jm button").css("color","#FFFFFF");
                   }else if(RegisterJM == "true"){
                      $("h2.shipping-period").css("display","block");
                     $(".jmc-cart-wishlist.right button.btn.btn--full.add-to-cart.btn--secondary span").text("Register");
                     $(".jmc-cart-wishlist.right button.btn.btn--full.add-to-cart.btn--secondary").prop('disabled', false);
                     $("div#custom-sticky-header-jm button").prop('disabled', false);
                     $("div#custom-sticky-header-jm button span").text("REGISTER");
                     $("div#custom-sticky-header-jm button").css("background-color","#000");
                     $("div#custom-sticky-header-jm button").css("color","#FFFFFF");
                   }
                   else if(JoinWaitListJM == "true"){
                      $("h2.shipping-period").css("display","block");
                     $(".jmc-cart-wishlist.right button.btn.btn--full.add-to-cart.btn--secondary span").text("Join Waitlist");
                     $(".jmc-cart-wishlist.right button.btn.btn--full.add-to-cart.btn--secondary").prop('disabled', false);
                     $("div#custom-sticky-header-jm button").prop('disabled', false);
                     $("div#custom-sticky-header-jm button span").text("Join Waitlist");
                     $("div#custom-sticky-header-jm button").css("background-color","#000");
                     $("div#custom-sticky-header-jm button").css("color","#FFFFFF");
                }
                 }else if(attributeValue=="deny"){
                   $("h2.shipping-period").css("display","none");
                   $(".jmc-cart-wishlist.right button.btn.btn--full.add-to-cart.btn--secondary span").text("Add to Cart");
                   $(".jmc-cart-wishlist.right button.btn.btn--full.add-to-cart.btn--secondary").prop('disabled', false);
                     $("div#custom-sticky-header-jm button").prop('disabled', false);
                     $("div#custom-sticky-header-jm button span").text("ADD TO CART");
                     $("div#custom-sticky-header-jm button").css("background-color","#000");
                     $("div#custom-sticky-header-jm button").css("color","#FFFFFF");
                 }else {
                   if(attributeValue=="oos" && JoinWaitListJM != "true"){
                    $("h2.shipping-period").css("display","none");
                    $("#notify-me-variant-options").css("display","block");
                    $(".inventoryWrapper").css("display","none");
                    $(".jmc-cart-wishlist.right button.btn.btn--full.add-to-cart.btn--secondary span").text("SOLD OUT");
                     $(".jmc-cart-wishlist.right button.btn.btn--full.add-to-cart.btn--secondary").prop('disabled', true);
                     $("div#custom-sticky-header-jm button").prop('disabled', true);
                     $("div#custom-sticky-header-jm button span").text("SOLD OUT");
                     $("div#custom-sticky-header-jm button").css("background-color","#d3d3d3");
                    $("div#custom-sticky-header-jm button").css("border","1px solid #d3d3d3");
                     $("div#custom-sticky-header-jm button").css("color","#3c3c3c");
                  }else if(attributeValue=="oos" && JoinWaitListJM == "true"){
                     $(".product-single__form .add-to-cart.btn--secondary:disabled").css("display","none");
                  }
              }
          }
    // Attach change event handler
    $('select.product-single__variants.no-js').change(function() {
      checkSelectedOption();
    });
    setTimeout(function() { 
      checkSelectedOption();
      }, 3000);
});


/*Hide sub-collection title on selected collections 7-11-2024*/
 $( document ).ready(function() {
  var collectionURL = $(location).attr("href");
  if (collectionURL == "https://wholesale.altenew.com/collections/new") {
    $("div#subCollection-list .collection-item--below .collection-item__title").css("display","none");
  }
});

/*Update the Privacy Policy Page Title*/
 $(document).ready(function () {
    let titlePrivacyPolicy = $(".shopify-policy__title h1");
    let titledatasalesoptOut = $("header.hc-header.section-header h1.section-header__title");
    let titledatasalesoptOutnav = $("nav.breadcrumb span:nth-child(3)");
   
    if (titlePrivacyPolicy.text().trim() === "Privacy policy") {
        titlePrivacyPolicy.text("Privacy Notice");
    }

    if (titledatasalesoptOut.text().trim() === "Do not sell or share my personal information") {
        titledatasalesoptOut.text("Do Not Sell or Share My Personal Data");
    }

    if (titledatasalesoptOutnav.text().trim() === "Do not sell or share my personal information") {
        titledatasalesoptOutnav.text("Do Not Sell or Share My Personal Data");
    }

});

/*Move bundle discount AOV widget before the description PDP 4/30/2025*/
$(document).ready(function(){
  $(".Avada-Bundle-Offer__Volume").css ("margin-bottom","15px");
  setTimeout(function() { 
  $(".Avada-Bundle-Offer__Volume").insertBefore("div#jm-desc-block-wh");
  }, 3000);
});

/*JM added for bundle listing description will show 5/2/2025*/
/* 7/28/2026 - variant metafield custom.description now takes priority.
   Resolution order per variant:
     1. .pdp-variant-description[data-variant-id] block (variant metafield)
     2. [data-pdp-description-fallback] block (product description)
     3. legacy .tabcontent[data-index] blocks inside the product description */
$(document).ready(function () {
  function getSelectedVariantId() {
    var $master = $('select[name="id"][data-product-select]').first();
    if ($master.length && $master.val()) return String($master.val());

    var match = window.location.search.match(/[?&]variant=(\d+)/);
    return match ? match[1] : null;
  }

  // Variant metafield descriptions, matched by variant id (not position).
  function updateVariantDescription(variantId) {
    var $blocks = $('.pdp-variant-description');
    if (!$blocks.length) return;

    var id = variantId || getSelectedVariantId();
    var $target = id ? $blocks.filter('[data-variant-id="' + id + '"]') : $();
    var $fallback = $('[data-pdp-description-fallback]');

    $blocks.hide();

    if ($target.length) {
      $target.show();
      $fallback.hide();
    } else {
      // No description on this variant - show the product description instead.
      $fallback.show();
    }
  }

  // Legacy positional blocks authored inside the product description.
  function updateSelectedIndex() {
    var $allTabs = $('.tabcontent[data-index]');
    if (!$allTabs.length) return;

    var selectedIndex = $('.variant-wrapper.variant-wrapper--dropdown .variant-input-wrap select option:selected').index()+1;

    // Hide all tabcontent elements with data-index
    $allTabs.hide().addClass('hc-hidden');

    // Reveal the matching one
    $('.tabcontent[data-index="' + selectedIndex + '"]')
      .removeClass('hc-hidden')
      .css('display', 'contents');

    // No height adjustment here - the container this used to size
    // (.single__meta_desc) is not rendered by this theme any more.
  }

  function refreshDescription(variantId) {
    updateVariantDescription(variantId);
    updateSelectedIndex();
  }

  // Run on page load
  refreshDescription();

  // Run on change - covers dropdown, radio and swatch pickers
  document.addEventListener('variant:change', function (evt) {
    var variant = evt.detail && evt.detail.variant;
    refreshDescription(variant ? String(variant.id) : null);
  });

  $('.variant-wrapper.variant-wrapper--dropdown .variant-input-wrap select').on('change', function () {
    refreshDescription();
  });
});

/*AOV Bundle Feature Alternative solution for now for the products reflect on cart*/
$(document).ready(function() {
  $(document).on('click', 'button.Avada-Offer__ButtonAddToCart', function() {
    setTimeout(function() {
      if ($('button.Avada-Offer__ButtonAddToCart').is(':visible')) {
          location.reload();
      }
    }, 3500);
  });
});

/*Cart drawer item remove 5/22/2025*/
  $(document).on('click', '.remove-cart-item', function(e) {
  e.preventDefault();
  const $cartItem = $(this).closest('.cart__item');
  const $qtyWrapper = $cartItem.find('.js-qty__wrapper');
  const $input = $qtyWrapper.find('.js-qty__num');
  const $minusBtn = $qtyWrapper.find('.js-qty__adjust--minus');

  // Set quantity to 0 and trigger native minus click
  $input.val(0);
  $minusBtn.trigger('click');
});


/*Products Countdown Timer 1/8/2024*/
    $(document).ready(function () {
      var countdownTimer = $(".countdown-container").data('countdown-timer');
       if (countdownTimer) {
          // Explicitly define the target end time in New York time
      let targetEndTime = countdownTimer;
  
      // Parse the target time into a Date object
      let countdownDate = new Date(
          new Intl.DateTimeFormat("en-US", {
              timeZone: "America/New_York",
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: true,
          }).format(new Date(targetEndTime))
      );
  
      // Start the countdown
      var x = setInterval(function () {
          // Get the current time in New York time
          let now = new Date().toLocaleString("en-US", { timeZone: "America/New_York" });
          now = new Date(now);
  
          // Calculate the remaining time
          let distance = countdownDate - now;
  
          if (distance >= 0) {
              let days = Math.floor(distance / (1000 * 60 * 60 * 24));
              let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
              let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
              let seconds = Math.floor((distance % (1000 * 60)) / 1000);
  
              $('#countdown').html(`${days}d ${hours}h ${minutes}m ${seconds}s`);
          } else {
              clearInterval(x);
              $('.countdown-container').css("display","none");
          }
          }, 1000);
       }
  });

  /*For variant discount code 6-23-2023*/
  $(document).ready(function() {
  function updateBulletList() {
    var selectedOption = $('.template-product .variant-input-wrap select').val(); // Get the selected option value
    var bulletIndex = $('.template-product .variant-input-wrap select').prop('selectedIndex'); // Get the selected option index
    
    // Update the bullet list based on the selected option index
    $('.template-product #variantDiscountCodeList li').eq(bulletIndex).show().siblings().hide();
  }

  // Trigger the function on page load
  updateBulletList();

  // Event listener for option list change
  $('.template-product .variant-input-wrap select').change(function() {
    updateBulletList();
  });
});

}

// Cart drawer remove (AJAX) - KEY-BASED + SAFE FALLBACK
document.addEventListener(
  "click",
  async (e) => {
    const btn = e.target.closest("button.jm-remove-btn");
    if (!btn) return;

    const inDrawer = btn.closest("#CartDrawer, .drawer, .cart-drawer, [data-cart-drawer], [data-drawer]");
    if (!inDrawer) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    // ✅ Use KEY (stable), not line (shifts)
    const key = btn.getAttribute("data-key");
    if (!key) {
      console.error("Remove: missing data-key on button", btn);
      return;
    }

    const cartItem = btn.closest(".cart__item");
    btn.disabled = true;

    try {
      console.log("🗑️ Removing key:", key);

      // Remove from backend (key-based)
      const res = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
        body: JSON.stringify({ id: key, quantity: 0 }),
      });

      // If apps break the request, recover instead of dying
      if (!res.ok) {
        console.warn(`[JM Remove] change.js failed (${res.status}). Attempting recovery...`);

        // Fallback: force clear cart only if we are likely removing last items / apps interfere
        await fetch("/cart.js", { headers: { "Accept": "application/json" } })
          .then(r => r.json())
          .then(async (cart) => {
            // If cart is already empty or about to be, just clear to stabilize
            if (!cart || !cart.items || cart.items.length <= 1) {
              await fetch("/cart/clear.js", { method: "POST", credentials: "same-origin" });
            }
          })
          .catch(() => {});

        // Refresh UI after recovery
        if (window.theme && window.theme.cart && typeof window.theme.cart.getCart === "function") {
          window.theme.cart.getCart();
        }
        if (typeof window.jmSyncDrawerThresholdFromServer === "function") {
          window.jmSyncDrawerThresholdFromServer();
        }

        // Don't show popup; we recovered
        btn.disabled = false;
        return;
      }

      const cart = await res.json();
      console.log("✅ Item removed from cart");

      // Animation
      if (cartItem) {
        cartItem.style.transition = "opacity 0.3s, transform 0.3s";
        cartItem.style.opacity = "0";
        cartItem.style.transform = "translateX(50px)";
        setTimeout(() => cartItem.remove(), 300);
      }

      // ✅ Update subtotal + threshold immediately if available
      if (typeof window.jmUpdateDrawerThresholdUI === "function") {
        window.jmUpdateDrawerThresholdUI(cart);
      }

      // ✅ Update empty state if available
      if (typeof window.jmToggleCartDrawerEmptyState === "function" && typeof cart.item_count !== "undefined") {
        window.jmToggleCartDrawerEmptyState(cart.item_count);
      }

      // Let Impulse re-render properly
      if (window.theme && window.theme.cart && typeof window.theme.cart.getCart === "function") {
        console.log("🔄 Calling theme.cart.getCart()");
        window.theme.cart.getCart();
      }

      // Safety: also sync from /cart.js (covers app side effects)
      if (typeof window.jmSyncDrawerThresholdFromServer === "function") {
        window.jmSyncDrawerThresholdFromServer();
      }

      btn.disabled = false;
    } catch (err) {
      console.error("❌ Remove failed:", err);

      // Best-effort recovery without annoying popup loops
      if (typeof window.jmSyncDrawerThresholdFromServer === "function") {
        window.jmSyncDrawerThresholdFromServer();
      }

      alert("Could not remove item. Please try again.");
      btn.disabled = false;
    }
  },
  true
);


document.addEventListener('DOMContentLoaded', function () {
  // Open the first accordion/tab on product pages
  var firstAccordion =
    document.querySelector('.template-product .product-block--tab details') ||
    document.querySelector('.template-product .product-block--tab [data-tab]') ||
    document.querySelector('.template-product .product-block--tab');

  // If it's a <details>, open it
  if (firstAccordion && firstAccordion.tagName && firstAccordion.tagName.toLowerCase() === 'details') {
    firstAccordion.open = true;
  }

  // If theme uses a clickable header/summary inside, click it once
  var summary = firstAccordion ? firstAccordion.querySelector('summary, button, [aria-expanded]') : null;
  if (summary && summary.getAttribute('aria-expanded') === 'false') {
    summary.click();
  }
});


document.addEventListener("DOMContentLoaded", function () {
  // only on product pages
  if (!document.body.classList.contains("template-product")) return;

  // find the quantity input used by Impulse
  var qtyInput = document.querySelector(
    '.template-product .qty-atc-wrap input[name="quantity"].js-qty__num, ' +
    '.template-product .qty-atc-wrap input[name="quantity"]'
  );

  if (!qtyInput) return;

  // Ensure it has a starting value
  if (!qtyInput.value || qtyInput.value === "0") qtyInput.value = "1";

  // Trigger the theme's listeners so it paints/updates UI immediately
  qtyInput.dispatchEvent(new Event("input", { bubbles: true }));
  qtyInput.dispatchEvent(new Event("change", { bubbles: true }));

  // Some themes only update after focus/blur
  qtyInput.focus({ preventScroll: true });
  qtyInput.blur();
});


/* =========================
   JM Lightbox (Media Marquee)
   Click marquee images -> open overlay
   ========================= */
(function () {
  const SELECTOR = '.pdp-mm__item'; // your anchors

  function buildLightbox() {
    if (document.querySelector('.jm-lb')) return;

    const el = document.createElement('div');
    el.className = 'jm-lb';
    el.innerHTML = `
      <div class="jm-lb__backdrop" data-jm-lb-close></div>
      <div class="jm-lb__panel">
        <button class="jm-lb__btn jm-lb__close" type="button" aria-label="Close" data-jm-lb-close>
          <svg viewBox="0 0 24 24" fill="none"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
        </button>

        <button class="jm-lb__btn jm-lb__prev" type="button" aria-label="Previous" data-jm-lb-prev>
          <svg viewBox="0 0 24 24" fill="none"><path d="M15 6l-6 6 6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </button>

        <img class="jm-lb__img" alt="" />

        <button class="jm-lb__btn jm-lb__next" type="button" aria-label="Next" data-jm-lb-next>
          <svg viewBox="0 0 24 24" fill="none"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </button>
      </div>
    `;
    document.body.appendChild(el);
  }

  function getMarqueeItems() {
    // Only grabs items from the marquee block(s)
    return Array.from(document.querySelectorAll(SELECTOR))
      .filter(a => a.closest('.product-block--media-marquee'));
  }

  function openAt(index) {
    buildLightbox();

    const lb = document.querySelector('.jm-lb');
    const img = lb.querySelector('.jm-lb__img');

    const items = getMarqueeItems();
    if (!items.length) return;

    // wrap index
    let i = ((index % items.length) + items.length) % items.length;

    lb.dataset.index = String(i);
    lb.dataset.count = String(items.length);

    const href = items[i].getAttribute('href');
    img.src = href;

    lb.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }

  function close() {
    const lb = document.querySelector('.jm-lb');
    if (!lb) return;
    lb.classList.remove('is-open');

    const img = lb.querySelector('.jm-lb__img');
    img.removeAttribute('src');

    document.documentElement.style.overflow = '';
  }

  function move(dir) {
    const lb = document.querySelector('.jm-lb');
    if (!lb || !lb.classList.contains('is-open')) return;

    const idx = parseInt(lb.dataset.index || '0', 10);
    openAt(idx + dir);
  }

  // Click handler (event delegation)
  document.addEventListener('click', function (e) {
    const a = e.target.closest(SELECTOR);
    if (!a) return;

    // only your marquee block
    if (!a.closest('.product-block--media-marquee')) return;

    e.preventDefault();

    const items = getMarqueeItems();
    const index = items.indexOf(a);
    if (index >= 0) openAt(index);
  });

  // Controls
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-jm-lb-close]')) return close();
    if (e.target.closest('[data-jm-lb-prev]')) return move(-1);
    if (e.target.closest('[data-jm-lb-next]')) return move(1);
  });

  // Keyboard
  document.addEventListener('keydown', function (e) {
    const lb = document.querySelector('.jm-lb');
    if (!lb || !lb.classList.contains('is-open')) return;

    if (e.key === 'Escape') close();
    if (e.key === 'ArrowLeft') move(-1);
    if (e.key === 'ArrowRight') move(1);
  });
})();

(function () {
  const OPEN_CLASS = 'jm-mobile-search-open';

  function lockScroll() {
    const y = window.scrollY || document.documentElement.scrollTop || 0;
    document.documentElement.dataset.jmScrollY = String(y);

    document.documentElement.classList.add(OPEN_CLASS);
    document.body.classList.add(OPEN_CLASS);

    document.body.style.position = 'fixed';
    document.body.style.top = `-${y}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function unlockScroll() {
    const y = parseInt(document.documentElement.dataset.jmScrollY || '0', 10);

    document.documentElement.classList.remove(OPEN_CLASS);
    document.body.classList.remove(OPEN_CLASS);

    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';

    window.scrollTo(0, y);
  }

  function openSearch() {
    lockScroll();
    const input = document.querySelector('#JmMobileSearch input[type="search"]');
    if (input) setTimeout(() => input.focus(), 50);
  }

  function closeSearch() {
    unlockScroll();
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('.jm-mobile-search-toggle')) {
      e.preventDefault();
      openSearch();
      return;
    }

    if (
      e.target.closest('.jm-mobile-search__close') ||
      e.target.closest('.jm-mobile-search__backdrop')
    ) {
      e.preventDefault();
      closeSearch();
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.body.classList.contains(OPEN_CLASS)) {
      closeSearch();
    }
  });
})();


/* ===========================
   JM Cart Badge Sync v2 (Impulse v8)
   - Updates .cart-link__bubble from /cart.js
   - Also updates:
     * drawer empty state (via window.jmToggleCartDrawerEmptyState)
     * subtotal + $200 threshold UI (via window.jmUpdateDrawerThresholdUI)
   - Triggers after:
     * fetch cart endpoints
     * XHR cart endpoints (Impulse/jQuery)
     * cart drawer clicks (remove/qty +/-)
     * cart:refresh events
=========================== */
(function () {
  // Debug marker (lets us verify file is running)
  window.jmBadgeSyncLoadedAt = Date.now();

  // Native fetch, captured before the patch below installs. syncBadgeNow uses
  // this so its own /cart.js request can't trip the cart listener and
  // reschedule itself in a loop.
  var jmNativeFetch = window.fetch ? window.fetch.bind(window) : null;

  // Native fetch, captured before the patch below installs. syncBadgeNow uses
  // this so its own /cart.js request can't trip the cart listener and
  // reschedule itself in a loop.
  var jmNativeFetch = window.fetch ? window.fetch.bind(window) : null;

  // Cart endpoints worth resyncing after. Reads (/cart.js, /cart?view=ajax)
  // are deliberately excluded.
  var JM_CART_MUTATION = /\/cart\/(add|change|update|clear)/;

  function log() {
    // comment out if you don't want console logs
    // console.log.apply(console, arguments);
  }

  function setBubbleCount(count) {
    var bubbles = document.querySelectorAll('.cart-link__bubble');
    if (!bubbles || !bubbles.length) {
      log('[JM Badge] No .cart-link__bubble found');
      return;
    }

    var n = Number(count) || 0;

    for (var i = 0; i < bubbles.length; i++) {
      var bubble = bubbles[i];
      bubble.textContent = n > 0 ? String(n) : '';
      if (bubble.classList) {
        bubble.classList.toggle('cart-link__bubble--visible', n > 0);
      }
    }

    log('[JM Badge] Updated count:', n);
  }

  function isJsonResponse(res) {
    try {
      var ct = (res.headers && res.headers.get && res.headers.get('content-type')) || '';
      return String(ct).toLowerCase().indexOf('application/json') !== -1;
    } catch (e) {
      return false;
    }
  }

  var timer = null;
  function syncBadgeDebounced() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(syncBadgeNow, 350); // allow chained cart requests
  }

  function syncBadgeNow() {
    return (jmNativeFetch || fetch)('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (res) {
        // Shopify cart.js should be JSON; guard anyway
        if (!isJsonResponse(res)) return res.json ? res.json() : null;
        return res.json();
      })
      .then(function (cart) {
        if (!cart) return;

        // 1) Bubble count
        if (typeof cart.item_count !== 'undefined') {
          setBubbleCount(cart.item_count);

          // 2) Drawer empty state (use GLOBAL function if available)
          if (typeof window.jmToggleCartDrawerEmptyState === 'function') {
            window.jmToggleCartDrawerEmptyState(cart.item_count);
          }
        }

        // 3) Subtotal + threshold UI (use GLOBAL function if available)
        if (typeof window.jmUpdateDrawerThresholdUI === 'function') {
          window.jmUpdateDrawerThresholdUI(cart);
        }
      })
      .catch(function (err) {
        console.warn('[JM Badge] sync failed:', err);
      });
  }

  // 0) Install once
  document.addEventListener('cart:refresh', syncBadgeDebounced);
  document.addEventListener('cart:updated', syncBadgeDebounced);
  document.addEventListener('cart:change', syncBadgeDebounced);

  // 1) Patch fetch (covers custom ATC and any app fetch)
  if (window.fetch && !window.jmFetchPatchedForBadgeV2) {
    window.jmFetchPatchedForBadgeV2 = true;
    var _fetch = window.fetch;

    window.fetch = function () {
      var url = arguments[0];
      var urlStr = '';

      try {
        if (typeof url === 'string') urlStr = url;
        else if (url && typeof url.url === 'string') urlStr = url.url;
      } catch (e) {}

      return _fetch.apply(this, arguments).then(function (res) {
        try {
          // Only resync after something that CHANGES the cart. Matching every
          // '/cart' URL also matched our own read of /cart.js.
          if (urlStr && JM_CART_MUTATION.test(urlStr)) {
            syncBadgeDebounced();
          }
        } catch (e) {}
        return res;
      });
    };
  }

  // 2) Patch XHR (Impulse/jQuery commonly uses this)
  if (window.XMLHttpRequest && !window.jmXHRPatchedForBadgeV2) {
    window.jmXHRPatchedForBadgeV2 = true;

    var XHRProto = window.XMLHttpRequest.prototype;
    var _open = XHRProto.open;
    var _send = XHRProto.send;

    XHRProto.open = function (method, url) {
      try {
        this.__jm_url = url;
      } catch (e) {}
      return _open.apply(this, arguments);
    };

    XHRProto.send = function () {
      try {
        var xhr = this;
        var url = xhr.__jm_url || '';
        xhr.addEventListener('loadend', function () {
          try {
            if (url && JM_CART_MUTATION.test(String(url))) {
              syncBadgeDebounced();
            }
          } catch (e) {}
        });
      } catch (e) {}

      return _send.apply(this, arguments);
    };
  }

  // 3) Catch cart drawer interactions directly (remove/qty +/-)
  // Capture phase so we still see it even if theme stops propagation
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t) return;

    if (
      (t.closest && t.closest('[data-cart-remove]')) ||
      (t.closest && t.closest('[data-quantity-minus]')) ||
      (t.closest && t.closest('[data-quantity-plus]')) ||
      (t.closest && t.closest('button[name="minus"]')) ||
      (t.closest && t.closest('button[name="plus"]')) ||
      (t.closest && t.closest('a[href*="cart/change"]')) ||
      (t.closest && t.closest('button[type="submit"][name="update"]'))
    ) {
      syncBadgeDebounced();
      return;
    }

    // trash/remove buttons
    if (
      t.closest &&
      t.closest('button') &&
      ((t.closest('button').getAttribute('aria-label') || '').toLowerCase().indexOf('remove') !== -1)
    ) {
      syncBadgeDebounced();
      return;
    }
  }, true);

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t) return;

    if (
      (t.name && String(t.name).toLowerCase().indexOf('quantity') !== -1) ||
      (t.classList && t.classList.contains('cart__qty-input')) ||
      (t.closest && t.closest('[data-cart-item]'))
    ) {
      syncBadgeDebounced();
    }
  }, true);

  // 4) Initial sync on load
  syncBadgeDebounced();

  // Expose manual trigger for debugging
  window.jmSyncCartBadgeNow = syncBadgeNow;

  log('[JM Badge] Installed v2');
})();


/* =========================================
   Newsletter Popup Text Fix
   ========================================= */

(function () {

  function fixNewsletterText() {
    var buttons = document.querySelectorAll('.newsletter-popup a, .newsletter-popup button');

    buttons.forEach(function (btn) {
      var text = btn.textContent.trim().toLowerCase();

      if (text === 'optional button' || text === 'optional') {
        btn.textContent = 'No thanks';
      }
    });
  }

  function observePopup() {
    var observer = new MutationObserver(function () {
      fixNewsletterText();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    fixNewsletterText();
    observePopup();
  });

})();



/* ============================================
   JM: Ensure Flickity initializes for subcollections slider
   ============================================ */
(function () {
  function initSubcollectionsFlickity() {
    var el = document.querySelector('.jm-subcollections-carousel');
    if (!el) return;

    // If Flickity isn't present, bail (theme should include it)
    if (typeof window.Flickity !== 'function') return;

    // Avoid double-init
    if (el.classList.contains('flickity-enabled')) return;

    try {
      var opts = {};
      var raw = el.getAttribute('data-flickity');
      if (raw) opts = JSON.parse(raw);

      // Init
      new window.Flickity(el, opts);
    } catch (e) {
      // If JSON parse fails for any reason, init with defaults
      try {
        new window.Flickity(el, {
          cellAlign: 'center',
          contain: true,
          wrapAround: false,
          pageDots: true,
          prevNextButtons: true
        });
      } catch (e2) {}
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initSubcollectionsFlickity();
    setTimeout(initSubcollectionsFlickity, 300);
    setTimeout(initSubcollectionsFlickity, 1000);
  });

  // Shopify section reloads (Theme Editor / AJAX)
  document.addEventListener('shopify:section:load', function () {
    initSubcollectionsFlickity();
    setTimeout(initSubcollectionsFlickity, 100);
  });
})();


/* Stampwheel: stop iWish link from opening new tab / navigating */
(function () {
  function isStampwheel() {
    return location.pathname.indexOf("/products/stampwheel") !== -1;
  }

  function fix() {
    if (!isStampwheel()) return;

    var a = document.querySelector(".iwish-app-block-product a.iWishAdd");
    if (!a) return;

    // stop the new tab
    a.removeAttribute("target");

    // keep href as-is (DON'T set href="#"), just prevent navigation
    if (!a.dataset.jmBound) {
      a.addEventListener("click", function (e) {
        e.preventDefault();
        // IMPORTANT: do NOT stopPropagation — let iWish handle it
      });
      a.dataset.jmBound = "1";
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    fix();
    setTimeout(fix, 500);
    setTimeout(fix, 1500);
    setTimeout(fix, 3000);
  });
})();

/* =========================================================
   JM FIX (Bulletproof): Variant dropdown -> correct variant ID for ALL add-to-cart flows
   - Computes selected variant from /products/<handle>.js
   - Writes to ALL forms input[name="id"] (prefers .hc-add)
   - Stores selected variant globally: window.__jmSelectedVariantId
   - Forces variant id into ANY /cart/add request:
       - HTML form submit
       - fetch()
       - XMLHttpRequest (XHR)
   This prevents apps (ex: Avada) from hijacking and sending the wrong id.

   Target problem: selecting "Stencil Set" adds "Complete Bundle"
   ========================================================= */
(function () {
  if (!location.pathname.includes('/products/')) return;

  // ---------------------------
  // Helpers
  // ---------------------------
  function getHandleFromURL() {
    const part = location.pathname.split('/products/')[1];
    return part ? part.split('/')[0] : null;
  }

  function findOptionSelect() {
    // Prefer Impulse option selector IDs
    let sel = document.querySelector('select[id*="SingleOptionSelector"], select[id*="OptionSelector"]');
    if (sel) return sel;

    // Fallback: any select that contains "Stencil Set" option label
    const all = Array.from(document.querySelectorAll('select'));
    return all.find(s => s.options?.length >= 2 && Array.from(s.options).some(o => /Stencil Set/i.test(o.textContent))) || null;
  }

  async function fetchProductJSON(handle) {
    const res = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
    if (!res.ok) throw new Error(`Failed to fetch /products/${handle}.js (${res.status})`);
    return await res.json();
  }

  function matchVariantByOption(product, selectedOptions) {
    if (!product || !Array.isArray(product.variants)) return null;

    // Your product is single-option: option1 matches dropdown value exactly ("Stencil Set")
    const s1 = selectedOptions[0] ?? null;

    return product.variants.find(v => (s1 === null || v.option1 === s1)) || null;
  }

  function setIdOnAllForms(variantId) {
    const forms = Array.from(document.querySelectorAll('form[action^="/cart/add"]'));
    forms.forEach(form => {
      // Prefer hc-add input if present
      let idInput = form.querySelector('input.hc-add[name="id"]') || form.querySelector('input[name="id"]');

      // If missing, create it (some apps submit forms without the hidden id)
      if (!idInput) {
        idInput = document.createElement('input');
        idInput.type = 'hidden';
        idInput.name = 'id';
        form.appendChild(idInput);
      }

      idInput.value = String(variantId);

      // Enable ATC if disabled
      const atcBtn = form.querySelector('button[name="add"], button[type="submit"]');
      if (atcBtn) atcBtn.disabled = false;
    });
  }

  // ---------------------------
  // Global state
  // ---------------------------
  let cachedProduct = null;
  let fetching = null;

  async function ensureProductLoaded() {
    if (cachedProduct) return cachedProduct;
    if (fetching) return fetching;

    const handle = getHandleFromURL();
    if (!handle) throw new Error('Could not detect product handle from URL.');

    fetching = fetchProductJSON(handle)
      .then(p => { cachedProduct = p; return p; })
      .finally(() => { fetching = null; });

    return fetching;
  }

  async function computeAndSetSelectedVariant(preferEl) {
    const select = findOptionSelect();
    if (!select) return null;

    const selectedOptions = [select.value];
    const product = await ensureProductLoaded();

    const variant = matchVariantByOption(product, selectedOptions);
    if (!variant || !variant.id) {
      console.warn('[JM Variant Fix] No matching variant for:', selectedOptions);
      return null;
    }

    // Store globally (used by fetch/XHR interceptors)
    window.__jmSelectedVariantId = String(variant.id);

    // Also push into all forms on the page
    setIdOnAllForms(variant.id);

    return variant.id;
  }

  // ---------------------------
  // Force variant into fetch() requests to /cart/add
  // ---------------------------
  function installFetchInterceptor() {
    if (window.__jmFetchInterceptInstalled) return;
    window.__jmFetchInterceptInstalled = true;

    const originalFetch = window.fetch;

    window.fetch = function (input, init) {
      try {
        const selectedId = window.__jmSelectedVariantId;
        if (!selectedId) return originalFetch.apply(this, arguments);

        let url = '';
        let method = 'GET';
        let body = null;
        let headers = null;
        let creds = null;

        if (typeof input === 'string') {
          url = input;
          method = (init && init.method) ? init.method : 'GET';
          body = init && init.body;
          headers = init && init.headers;
          creds = init && init.credentials;
        } else if (input && typeof input === 'object') {
          url = input.url || '';
          method = input.method || (init && init.method) || 'GET';
          body = (init && init.body) || input.body;
          headers = (init && init.headers) || input.headers;
          creds = (init && init.credentials) || input.credentials;
        }

        const isAdd =
          typeof url === 'string' &&
          (url.includes('/cart/add') || url.includes('/cart/add.js')) &&
          String(method).toUpperCase() === 'POST';

        if (!isAdd) return originalFetch.apply(this, arguments);

        // Modify body to force id
        let newBody = body;

        if (body instanceof FormData) {
          const fd = new FormData();
          for (const [k, v] of body.entries()) fd.append(k, v);
          fd.set('id', selectedId);
          newBody = fd;
        } else if (body instanceof URLSearchParams) {
          const usp = new URLSearchParams(body.toString());
          usp.set('id', selectedId);
          newBody = usp;
        } else if (typeof body === 'string') {
          // Most apps send "application/x-www-form-urlencoded"
          const usp = new URLSearchParams(body);
          usp.set('id', selectedId);
          newBody = usp.toString();
        } else if (!body) {
          // If no body, create one
          const usp = new URLSearchParams();
          usp.set('id', selectedId);
          newBody = usp;
        }

        const nextInit = Object.assign({}, init || {});
        nextInit.method = method;
        nextInit.body = newBody;
        if (headers) nextInit.headers = headers;
        if (creds) nextInit.credentials = creds;

        return originalFetch.call(this, url, nextInit);
      } catch (e) {
        return originalFetch.apply(this, arguments);
      }
    };
  }

  // ---------------------------
  // Force variant into XHR requests to /cart/add
  // ---------------------------
  function installXHRInterceptor() {
    if (window.__jmXHRInterceptInstalled) return;
    window.__jmXHRInterceptInstalled = true;

    const origOpen = XMLHttpRequest.prototype.open;
    const origSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__jmMethod = method;
      this.__jmUrl = url;
      return origOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function (data) {
      try {
        const selectedId = window.__jmSelectedVariantId;
        const url = this.__jmUrl || '';
        const method = String(this.__jmMethod || 'GET').toUpperCase();

        const isAdd =
          selectedId &&
          (String(url).includes('/cart/add') || String(url).includes('/cart/add.js')) &&
          method === 'POST';

        if (!isAdd) return origSend.apply(this, arguments);

        let newData = data;

        if (data instanceof FormData) {
          data.set('id', selectedId);
          newData = data;
        } else if (data instanceof URLSearchParams) {
          data.set('id', selectedId);
          newData = data;
        } else if (typeof data === 'string') {
          const usp = new URLSearchParams(data);
          usp.set('id', selectedId);
          newData = usp.toString();
        } else if (!data) {
          const usp = new URLSearchParams();
          usp.set('id', selectedId);
          newData = usp.toString();
        }

        return origSend.call(this, newData);
      } catch (e) {
        return origSend.apply(this, arguments);
      }
    };
  }

  // ---------------------------
  // Bind events
  // ---------------------------
  function bind() {
    // Install interceptors FIRST so apps can't win
    installFetchInterceptor();
    installXHRInterceptor();

    // Initial compute on load
    computeAndSetSelectedVariant(document).catch(e => console.warn('[JM Variant Fix] init error:', e));

    // Recompute on dropdown change
    document.addEventListener('change', function (e) {
      const t = e.target;
      if (!t || t.tagName !== 'SELECT') return;

      const isOurSelect =
        (t.id || '').includes('SingleOptionSelector') ||
        (t.id || '').includes('OptionSelector') ||
        (t.options?.length >= 2 && Array.from(t.options).some(o => /Stencil Set/i.test(o.textContent)));

      if (!isOurSelect) return;

      computeAndSetSelectedVariant(t).catch(err => console.warn('[JM Variant Fix] change error:', err));
    }, true);

    // On submit, just ensure selected variant is computed and injected (do NOT block)
    document.addEventListener('submit', function (e) {
      const form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      if (!form.action || !form.action.includes('/cart/add')) return;

      // Best effort: compute & inject, but let submit proceed
      computeAndSetSelectedVariant(form).catch(() => {});
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();

/* ==========================================================================
   Shopify Admin Preview Bar (PBarNextFrameWrapper) Dynamic Adjustments
   ========================================================================== */
(function() {
  function adjustForPreviewBar() {
    var pbar = document.getElementById('PBarNextFrameWrapper') || document.querySelector('.PBarNextFrameWrapper');
    var pbarHeight = 0;
    if (pbar && pbar.offsetHeight > 0) {
      pbarHeight = pbar.offsetHeight;
    }
    
    // Set custom property on document element
    document.documentElement.style.setProperty('--pbar-height', pbarHeight + 'px');
  }

  // Observe body changes to detect when PBarNextFrameWrapper is injected or resized
  var observer = new MutationObserver(adjustForPreviewBar);
  document.addEventListener('DOMContentLoaded', function() {
    adjustForPreviewBar();
    observer.observe(document.body, { childList: true, subtree: true });
    
    // Periodically check just in case it loads extremely late
    var interval = setInterval(adjustForPreviewBar, 1000);
    // Stop checking after 15 seconds to save resources
    setTimeout(function() { clearInterval(interval); }, 15000);
  });
  window.addEventListener('resize', adjustForPreviewBar);
})();

/* ==========================================================================
   Shopify Cookie Banner Observers and State Adjustments
   ========================================================================== */
(function () {
  function isBannerVisible() {
    var banner = document.getElementById('shopify-pc__banner');
    if (!banner) return false;

    var style = window.getComputedStyle(banner);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
      return false;
    }

    return banner.offsetHeight > 0;
  }

  function updateCookieState() {
    var visible = isBannerVisible();
    document.body.classList.toggle('shopify-cookie-visible', visible);
  }

  function initObservers() {
    // Watch DOM for banner changes
    var observer = new MutationObserver(function () {
      updateCookieState();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Re-check after clicks (accept/decline)
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t) return;

      if (t.classList.contains('shopify-pc__banner__btn') || t.closest('#shopify-pc__banner')) {
        setTimeout(updateCookieState, 50);
        setTimeout(updateCookieState, 200);
        setTimeout(updateCookieState, 600);
      }
    }, true);

    window.addEventListener('resize', updateCookieState);
  }

  document.addEventListener('DOMContentLoaded', function () {
    updateCookieState();
    initObservers();

    // Late loads safety
    setTimeout(updateCookieState, 500);
    setTimeout(updateCookieState, 1500);
    setTimeout(updateCookieState, 3000);
  });
})();

/* ==========================================================================
   Shopify Cart Utilities & AJAX Add-To-Cart Form Handler
   ========================================================================== */
if (typeof window.Shopify === 'undefined') { window.Shopify = {}; }
if (typeof window.Shopify.getCart === 'undefined') {
  window.Shopify.getCart = function(callback, cart) {
    if (!cart) {
      return jQuery.getJSON('/cart.js', function (cartData, textStatus, xhr) {
        if (typeof callback === 'function') {
          callback(cartData, textStatus, xhr);
        } else if (typeof window.Shopify.onCartUpdate === 'function') {
          window.Shopify.onCartUpdate(cartData);
        }
      });
    } else {
      if (typeof callback === 'function') {
        callback(cart);
      } else if (typeof window.Shopify.onCartUpdate === 'function') {
        window.Shopify.onCartUpdate(cart);
      }
    }
  };
}

jQuery(document).ready(function($) {
  $(document).on('submit', '.hc-add-to-cart, .hc-add-to-cart-but-product', function(e) {
    e.preventDefault();
    $(this).find('input[name="event_id"]').remove();
    const formData = $(this).serialize();
    $.ajax({
      url: '/cart/add.js',
      data: formData,
      dataType: 'json',
      method: 'post',
      success: async function(cart0) {
        await window.Shopify.getCart();
        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
        const cart = await fetch('/cart.js').then(res => res.json());
        if (cart.items.length > 0) {
          $('.cart-link__bubble').addClass('cart-link__bubble--visible').text(cart.item_count);
        } else {
          $('.cart-link__bubble').removeClass('cart-link__bubble--visible').text('');
        }
      },
      error: function(message) {
        console.error('[Add to Cart AJAX Error]', message);
      }
    });
  });
});

/* ==========================================================================
   Product Template Out-Of-Stock (OOS) & 'Notify Me' Sync State UI
   ========================================================================== */
(function () {
  // Safe execution check: Only run on Product PDP pages
  function shouldRun() {
    if (document.body && (document.body.classList.contains('template-product') || document.body.id === 'jm-custom-product')) return true;
    if (window.location.pathname.includes('/products/')) return true;
    return false;
  }

  if (!shouldRun()) return;
  if (window.__JM_ATC_NOTIFY_UI_ONLY_V1__) return;
  window.__JM_ATC_NOTIFY_UI_ONLY_V1__ = true;

  var SOLD_OUT_TEXT = 'SOLD OUT';
  var DEFAULT_IN_STOCK_TEXT = 'ADD TO CART';

  var productCache = null;
  var syncTimer = null;

  function debounce(fn, delay) {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(fn, delay || 80);
  }

  function getHandleFromUrl() {
    var m = window.location.pathname.match(/\/products\/([^\/\?]+)/);
    return m ? m[1] : null;
  }

  function fetchProductJsonOnce() {
    if (productCache) return Promise.resolve(productCache);

    var handle = getHandleFromUrl();
    if (!handle) return Promise.reject(new Error('No product handle'));

    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        productCache = json;
        return productCache;
      });
  }

  function normalize(x) {
    return String(x == null ? '' : x).trim();
  }

  function isVisible(el) {
    if (!el) return false;
    var cs = window.getComputedStyle(el);
    if (!cs || cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0') return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  function getMainForm() {
    var forms = Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"]'));
    if (!forms.length) return null;

    for (var i = 0; i < forms.length; i++) {
      var f = forms[i];
      var btn = f.querySelector('button[type="submit"], button[name="add"], input[type="submit"]');
      if (btn && isVisible(btn)) return f;
    }
    return forms[0] || null;
  }

  function getScope(form) {
    return (
      (form && form.closest('[data-section-id]')) ||
      (form && form.closest('section')) ||
      (form && form.closest('.product')) ||
      document
    );
  }

  function getIdField(form) {
    if (!form) return null;
    return form.querySelector('[name="id"]');
  }

  function getVisibleATCElement(form, scope) {
    if (form) {
      var btn = form.querySelector('button[type="submit"]') || form.querySelector('button[name="add"]');
      if (btn && isVisible(btn)) return btn;

      var inputSubmit = form.querySelector('input[type="submit"]');
      if (inputSubmit && isVisible(inputSubmit)) return inputSubmit;
    }

    scope = scope || document;
    var candidates = Array.prototype.slice.call(scope.querySelectorAll('button,a,input[type="submit"]'))
      .filter(function (el) {
        var t = '';
        if (el.tagName === 'INPUT') t = (el.value || '').trim();
        else t = ((el.innerText || el.textContent || '') + '').trim();
        return /add to cart/i.test(t) || /sold out/i.test(t);
      })
      .filter(isVisible);

    candidates.sort(function (a, b) {
      var ra = a.getBoundingClientRect(), rb = b.getBoundingClientRect();
      return (rb.width * rb.height) - (ra.width * ra.height);
    });

    return candidates[0] || null;
  }

  function getNotifyWrapper(scope) {
    if (!scope) return null;
    return scope.querySelector('[data-notifyme-wrapper]') || scope.querySelector('.notifyme-jm-custom');
  }

  function getNotifyButton(scope) {
    if (!scope) scope = document;
    return scope.querySelector('.klaviyo-bis-trigger');
  }

  function setNotifyVisible(scope, show) {
    var wrap = getNotifyWrapper(scope);
    if (!wrap) return;
    if (show) wrap.removeAttribute('hidden');
    else wrap.setAttribute('hidden', '');
  }

  function setNotifyVariantId(scope, id) {
    var btn = getNotifyButton(scope);
    if (!btn) return;
    btn.setAttribute('data-variant-id', String(id));
    btn.setAttribute('data-variant', String(id));
  }

  function rememberOriginalText(textTarget, atcEl) {
    if (!textTarget || textTarget.getAttribute('data-jm-orig-text')) return;

    var raw = '';
    if (atcEl && atcEl.tagName === 'INPUT') raw = (atcEl.value || '').trim();
    else raw = (textTarget.textContent || '').trim();

    if (!raw || raw.toUpperCase() === SOLD_OUT_TEXT) {
      textTarget.setAttribute('data-jm-orig-text', DEFAULT_IN_STOCK_TEXT);
      return;
    }
    textTarget.setAttribute('data-jm-orig-text', raw);
  }

  function setATCState(atcEl, isOOS) {
    if (!atcEl) return;

    var isInput = (atcEl.tagName === 'INPUT');
    var textTarget = atcEl;

    if (!isInput && atcEl.querySelector) {
      textTarget = atcEl.querySelector('[data-add-to-cart-text]') || atcEl;
    }

    rememberOriginalText(textTarget, atcEl);

    if (isOOS) {
      atcEl.disabled = true;
      atcEl.setAttribute('aria-disabled', 'true');
      atcEl.classList.add('jm-atc-oos');

      if (isInput) atcEl.value = SOLD_OUT_TEXT;
      else textTarget.textContent = SOLD_OUT_TEXT;
    } else {
      atcEl.disabled = false;
      atcEl.removeAttribute('aria-disabled');
      atcEl.classList.remove('jm-atc-oos');

      var orig = (textTarget.getAttribute('data-jm-orig-text') || DEFAULT_IN_STOCK_TEXT).trim();
      if (!orig || orig.toUpperCase() === SOLD_OUT_TEXT) orig = DEFAULT_IN_STOCK_TEXT;

      if (isInput) atcEl.value = orig;
      else textTarget.textContent = orig;
    }
  }

  function setQtyState(scope, isOOS) {
    if (!scope) scope = document;

    var qtyWrapper = scope.querySelector('.quantity') || scope.querySelector('[data-quantity-wrapper]') || null;
    var qtyInput = scope.querySelector('input[name="quantity"]') || scope.querySelector('input[type="number"][name="quantity"]') || null;

    if (qtyInput) {
      qtyInput.disabled = !!isOOS;
      if (isOOS) qtyInput.setAttribute('aria-disabled', 'true');
      else qtyInput.removeAttribute('aria-disabled');
    }

    if (qtyWrapper) {
      if (isOOS) {
        qtyWrapper.style.display = 'none';
        qtyWrapper.setAttribute('hidden', '');
      } else {
        qtyWrapper.style.display = '';
        qtyWrapper.removeAttribute('hidden');
      }
    }
  }

  function findVariantById(product, id) {
    id = String(id || '');
    if (!id) return null;
    return (product.variants || []).find(function (v) { return String(v.id) === id; }) || null;
  }

  // Find variant dropdown in scope
  function getVariantTitleSelect(scope, form) {
    var root = (form && (form.closest('[data-section-id]') || form.closest('section') || form)) || scope || document;
    var selects = Array.prototype.slice.call(root.querySelectorAll('select'));
    selects = selects.filter(function (s) {
      if (!s) return false;
      if (s.name === 'id') return false;
      if ((s.className || '').toLowerCase().indexOf('jdgm-sort') !== -1) return false;
      return true;
    });

    return selects[0] || null;
  }

  function findVariantByTitle(product, title) {
    title = normalize(title);
    if (!title) return null;

    return (product.variants || []).find(function (v) {
      return normalize(v.title) === title;
    }) || null;
  }

  function syncUI() {
    var form = getMainForm();
    if (!form) return;

    var scope = getScope(form);

    fetchProductJsonOnce().then(function (product) {
      var variant = null;

      if (window.__jmSelectedVariantId) {
        variant = findVariantById(product, window.__jmSelectedVariantId);
      }

      if (!variant) {
        var idField = getIdField(form);
        if (idField && idField.value) {
          variant = findVariantById(product, idField.value);
        }
      }

      if (!variant) {
        var titleSelect = getVariantTitleSelect(scope, form);
        if (titleSelect) {
          variant = findVariantByTitle(product, titleSelect.value);
        }
      }

      if (!variant) return;

      var isOOS = (variant.available === false);

      setNotifyVariantId(scope, variant.id);
      setNotifyVisible(scope, isOOS);

      var atcEl = getVisibleATCElement(form, scope);
      setATCState(atcEl, isOOS);
      setQtyState(scope, isOOS);
    }).catch(function(){});
  }

  function init() {
    syncUI();

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;
      if (t.tagName === 'SELECT') debounce(syncUI, 120);
    }, true);

    document.addEventListener('variant:change', function () {
      debounce(syncUI, 80);
    });

    try {
      var mo = new MutationObserver(function () {
        debounce(syncUI, 160);
      });
      mo.observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(); // <--- Correctly closes the anonymous function
